export default [
    { icon: 'fa-file-contract', key: 'terms', label: 'labels.terms_of_service' },
    { icon: 'fa-shield-check', key: 'privacy', label: 'labels.privacy_policy' },
    { icon: 'fa-cookie', key: 'cookies', label: 'labels.cookie_policy' },
    { icon: 'fa-file-signature', key: 'dpa', label: 'labels.dpa' },
    { icon: 'fa-hospital', key: 'hipaa', label: 'labels.hipaa' },
    { icon: 'fa-server', key: 'sub-processors', label: 'labels.sub_processors' },
    { icon: 'fa-user-shield', key: 'dsar', label: 'labels.dsar' },
    { icon: 'fa-gift', key: 'lifetime-deal-terms', label: 'labels.lifetime_deal_terms' },
    { icon: 'fa-handshake', key: 'referral-program-terms', label: 'labels.referral_program' },
];
